export default function getObjectIds(ids: string) {
  if (ids.length > 0) {
    return { objectDb: ids.split(",")[0], objectId: ids.split(",")[1] };
  } else {
    return null;
  }
}
